import type { UpdateProcessWorkflowRequest } from 'shared/domain/process/types/requests';
import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { add as addRequest } from 'serviceWorker/db/httpRequests';
import { debugLog } from 'shared/logger/debugLog';
import type { ProcessWorkflowUpdateRequestModel } from 'serviceWorker/services/httpQueue/process/requestRunner';

export type UpdateProcessWorkflowPayload = UpdateProcessWorkflowRequest;

/** Resolves once the change is queued; its outcome follows as an event with the `uniqueId`. */
export function handleUpdateProcessWorkflow(
  payload: UpdateProcessWorkflowPayload
): Promise<void> {
  const { processId, workflowId, projectId, uniqueId } = payload;
  return processWorkflowUpdater.execute(
    processId,
    workflowId,
    projectId,
    uniqueId
  );
}

export interface UpdateProcessWorkflowUseCase {
  execute(
    processId: string,
    workflowId: string,
    projectId: string,
    uniqueId: string
  ): Promise<void>;
}

export class ProcessWorkflowUpdater implements UpdateProcessWorkflowUseCase {
  constructor(
    private addRequest: (
      request: ProcessWorkflowUpdateRequestModel
    ) => Promise<unknown>
  ) {}

  async execute(
    processId: string,
    workflowId: string,
    projectId: string,
    uniqueId: string
  ): Promise<void> {
    debugLog('ProcessWorkflowUpdater.execute', { processId, workflowId });
    const request: ProcessWorkflowUpdateRequestModel = {
      createdAt: Date.now(),
      method: 'PUT',
      url: `project/${projectId}/process/${processId}`,
      data: {
        processId,
        workflowId,
        projectId,
        uniqueId,
      },
      entityType: HttpRequestModelType.process,
      status: HttpRequestStatus.NEW,
    };

    await this.addRequest(request);
  }
}

export const processWorkflowUpdater = new ProcessWorkflowUpdater(addRequest);
